import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './header.component'

let module = angular.module('header', [
  uiRouter
])

.component('appHeader', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/header/index.js